/**
 * Vite inlines `import.meta.env.VITE_*` at build time, so every value here ends up readable in
 * the bundle — none of them may be a secret.
 */
function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(`Missing environment variable ${name}. See .env for the expected keys.`)
  }
  return value
}

/**
 * For a value the app can do without: unset and blank both mean "not there". Exported for its
 * test; the app reads the values through `config`.
 */
export function optional(value: string | undefined): string | undefined {
  return value?.trim() || undefined
}

export const config = {
  apiUrl: required('VITE_API_URL', import.meta.env.VITE_API_URL).replace(/\/$/, ''),
  keycloakUrl: required('VITE_KEYCLOAK_URL', import.meta.env.VITE_KEYCLOAK_URL).replace(/\/$/, ''),
  keycloakClientId: required('VITE_KEYCLOAK_CLIENT_ID', import.meta.env.VITE_KEYCLOAK_CLIENT_ID),
  // The install links of the companion iOS apps. An app without one is left out of the sidebar.
  mediathekUrl: optional(import.meta.env.VITE_MEDIATHEK_URL),
  leadAppUrl: optional(import.meta.env.VITE_LEAD_APP_URL),
} as const
